import React from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

const TOOLTIP_ID = "funding-type-help-tooltip";

const fundingTypeHelpContent = (
  <div className="text-left text-xs text-white max-w-xs p-1">
    <p className="font-semibold mb-2">Funding types</p>
    <ul className="space-y-1.5 list-none">
      <li><strong>NDIS</strong> — National Disability Insurance Scheme. GST-free. May require service category and location.</li>
      <li><strong>Aged Care</strong> — Aged care funding (e.g. HCP, CHSP). GST-free. Service category is optional (NDIS-style categories do not apply).</li>
      <li><strong>Private</strong> — Privately funded / out-of-pocket. 10% GST applies.</li>
      <li><strong>Other</strong> — Other or unspecified funding sources. 10% GST applies.</li>
    </ul>
  </div>
);

function FundingTypeHelpIcon() {
  return (
    <>
      <a data-tooltip-id={TOOLTIP_ID} className="inline-flex ml-1 cursor-pointer focus:outline-none" aria-label="Funding type help">
        <FaQuestionCircle className="text-gray-400 hover:text-gray-500 text-sm" />
      </a>
      <Tooltip
        id={TOOLTIP_ID}
        place="top"
        variant="dark"
        className="z-[100]"
        render={() => fundingTypeHelpContent}
      />
    </>
  );
}

export default FundingTypeHelpIcon;
